<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onCancel()">
    <div class="dialog-container" (click)="$event.stopPropagation()">
      <!-- Header -->
      <div class="dialog-header">
        <div class="header-content">
          <h2 class="dialog-title">{{ t('lang.skip_confirm_title') }}</h2>
        </div>
        <button class="close-button" (click)="onCancel()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </div>

      <!-- Content -->
      <div class="dialog-content">
        <p class="message-text">
          {{
            t(skipConfirmMessageKey, {
              partner: partnerName,
              entity: integrationEntityName,
            })
          }}
        </p>
        <div class="info-box">
          <mzic-svg src="assets/icons/mzic-info-circle.svg" />
          <p>{{ t('lang.skip_confirm_info') }}</p>
        </div>
      </div>

      <!-- Footer -->
      <div class="dialog-footer">
        <button class="secondary-button" (click)="onCancel()">
          {{ t('lang.cancel') | uppercase }}
        </button>
        <button class="primary-button" (click)="onConfirm()">
          {{ t('lang.skip_confirm_yes') | uppercase }}
        </button>
      </div>
    </div>
  </div>
</ng-container>

